import { render, staticRenderFns } from "./OutstandingAccountPayables.vue?vue&type=template&id=382d82ed&"
import script from "./OutstandingAccountPayables.vue?vue&type=script&lang=js&"
export * from "./OutstandingAccountPayables.vue?vue&type=script&lang=js&"
import style0 from "./OutstandingAccountPayables.vue?vue&type=style&index=0&id=382d82ed&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports